export default "/images/vendor/jquery-ui/themes/base/ui-icons_cc0000_256x240.png?0085819bbded1954c054280cb41790d0";